export default __webpack_public_path__ + "static/media/PFSquareSansProMedium_35487.dab23b56.ttf";